import { render } from "./BrandMark.vue?vue&type=template&id=864a7ed2&scoped=true"
import script from "./BrandMark.vue?vue&type=script&lang=js"
export * from "./BrandMark.vue?vue&type=script&lang=js"

import "./BrandMark.css?vue&type=style&index=0&id=864a7ed2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864a7ed2"]])

export default __exports__